import type { IconSvgObject } from './types';

const MoleculesIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "13", r: "4", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "4", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "4", cy: "20", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "20", cy: "20", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 9V6M18.5 18.5L15 16M5.5 18.5L9 16", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default MoleculesIcon;
